import { objectSpread2 as _objectSpread2 } from './_virtual/_rollupPluginBabelHelpers.js';
import mergeWith$1 from 'lodash/mergeWith';
import memoize$1 from 'lodash/memoize';

var globalCssModule;
function setGlobalCssModule(cssModule) {
  globalCssModule = cssModule;
}
function mapToCssModules(className, cssModule) {
  if (className === void 0) {
    className = '';
  }

  if (cssModule === void 0) {
    cssModule = globalCssModule;
  }

  if (cssModule === undefined) {
    return className;
  }

  return className.split(' ').map(function (c) {
    return cssModule[c] || c;
  }).join(' ');
} // The first argument, cssModuleProp, is used as the cache key.
// This means it will always return the cached value if the first argument is same even if the second argument changes.

var memoMerge = memoize$1(function (cssModuleProp, defaultCssModule) {
  // Spread the cssModuleProp object so we don't mutate the original
  return mergeWith$1(_objectSpread2({}, cssModuleProp), defaultCssModule, function (oldValue, newValue) {
    if (oldValue) {
      if (oldValue.indexOf(newValue) > -1) {
        return oldValue;
      } else {
        return oldValue + " " + newValue;
      }
    } else {
      return newValue;
    }
  });
});
var mergeCssModules = function mergeCssModules(cssModuleProp, defaultCssModule) {
  if (cssModuleProp) {
    return memoMerge(cssModuleProp, defaultCssModule);
  } else {
    return defaultCssModule;
  }
};

export { mapToCssModules, mergeCssModules, setGlobalCssModule };
